
    var riot = require('riot')
    //src: starling/src/tags/drawing.html
riot.tag2('drawing',
  '<div show="{resizeEnabled}" class="region-resize-handle region-resize-handle--top region-resize-handle--left" onmouseenter="{showEdgeHandles}" onmouseleave="{hideEdgeHandles}"></div> <div show="{resizeEnabled}" class="region-resize-handle region-resize-handle--top region-resize-handle--right" onmouseenter="{showEdgeHandles}" onmouseleave="{hideEdgeHandles}"></div> <div show="{resizeEnabled}" class="region-resize-handle region-resize-handle--bottom region-resize-handle--left" onmouseenter="{showEdgeHandles}" onmouseleave="{hideEdgeHandles}"></div> <div show="{resizeEnabled}" class="region-resize-handle region-resize-handle--bottom region-resize-handle--right" onmouseenter="{showEdgeHandles}" onmouseleave="{hideEdgeHandles}"></div> <svg riot-viewbox="{getViewBox()}"> <path class="drawing-path" riot-d="{getPath()}" stroke-dasharray="{getDashArray()}" stroke-linecap="round" stroke-linejoin="round"></path> <path ref="dragPath" class="drawing-drag-path {drag-handle: showTools()}" riot-d="{getPath()}" onmouseenter="{handleDragBarMouseEnter}" onmouseleave="{handleDragBarMouseLeave}" data-move-enabled="{moveEnabled ? \'true\' : \'false\'}" data-drawing-id="{this.id}"></path> </svg>',
  '',
  'class="drawing {selected: isSelected} link-{instance.color}" riot-style="{getStyle()}" oncontextmenu="{summonMenu}" data-drawing-id="{this.id}" data-move-enabled="{moveEnabled ? \'true\' : \'false\'}"', function(opts) {
'use strict';

var _this = this;

var _interactjs = require('interactjs');

var _interactjs2 = _interopRequireDefault(_interactjs);

var _util = require('lib/util');

var _nodesUi = require('lib/nodes-ui');

var _selectionUi = require('lib/selection-ui');

var _constants = require('lib/constants');

var _escapeHtml = require('escape-html');

var _escapeHtml2 = _interopRequireDefault(_escapeHtml);

var _collaboratorsUi = require('lib/collaborators-ui');

var _drawingUi = require('lib/drawing-ui');

var _regionUi = require('lib/region-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.instance = store.getDrawing(this.id);
var canvas = opts.canvas;
this.resizeEnabled = false;
this.moveEnabled = false;
this.isInteractable = false;

canvas.drawingTags[this.id] = this;

this.on('mount', function () {
  var dragPath = _this.refs.dragPath;
  var _instance = _this.instance,
      height = _instance.height,
      width = _instance.width;

  _this.enableMovement();

  _this.aspectRatio = width / height;

  canvas.triggerPostinitialization();

  if (_this.showTools()) {
    $(dragPath).on('mousedown touchstart pointerdown', function (e) {
      canvas.hidePopups();
    });
    (0, _interactjs2.default)(dragPath).on('tap', function (e) {
      /* don't deselect if right clicking or ctrl+clicking */
      if (e.button && e.button === 2) return;
      if (e.ctrlKey) return;
      _this.toggleSelected(e);
    });
  }
});

this.getPath = function () {
  return _this.instance.path;
};

this.getStrokeWidth = function () {
  return _constants.DRAWING_WIDTHS_MAPPING[_this.instance.strokeWidth];
};

this.getViewBox = function () {
  var instance = _this.instance;
  var x = instance.x,
      y = instance.y,
      width = instance.width,
      height = instance.height;

  var stroke = _this.getStrokeWidth();

  return x - stroke + ' ' + (y - stroke) + ' ' + (width + stroke * 2) + ' ' + (height + stroke * 2);
};

this.getStrokeType = function () {
  return _this.instance.strokeType;
};

this.getStyle = function () {
  var instance = _this.instance;
  var left = instance.left,
      right = instance.right,
      top = instance.top,
      bottom = instance.bottom,
      opacity = instance.opacity;

  var stroke = _this.getStrokeWidth();

  var _opts$canvas$getMatri = _this.opts.canvas.getMatrix(),
      scale = _opts$canvas$getMatri.scale;

  return '\n        --drawing-stroke-width: ' + stroke + 'px;\n        width: ' + (right - left + stroke * 2) + 'px;\n        height: ' + (bottom - top + stroke * 2) + 'px;\n        left: ' + (left - stroke) + 'px;\n        top: ' + (top - stroke) + 'px;\n        stroke-opacity: ' + opacity + ';\n      ';
};

this.onResize = function (_ref) {
  var rect = _ref.rect,
      deltaRect = _ref.deltaRect;

  if (canvas.isViewOnly()) return;
  _drawingUi.drawingUI.applyResize({
    drawing: _this.instance,
    rect: (0, _util.scaleRect)({ rect: rect, canvas: canvas }),
    aspectRatio: _this.aspectRatio
  });

  _this.update();
};

this.onMoveStart = function (e) {
  if (canvas.isViewOnly()) return;

  _this.onResizeMoveStart(e);

  if (!_this.isSelected) {
    canvas.clearSelectedElements();
  }

  _drawingUi.drawingUI.resetDragData();
  _drawingUi.drawingUI.setPrevDrawingPosition(_this.instance);

  _regionUi.regionUI.prepareSelectedRegionsForMove();
  _regionUi.regionUI.prepareSelectedNodesForMove();

  canvas.multiSelectionIndicatorBox.hide();
};

this.onResizeMoveStart = function (e) {
  if (canvas.isViewOnly()) return;
  e.stopPropagation();
  var _instance2 = _this.instance,
      top = _instance2.top,
      left = _instance2.left,
      right = _instance2.right,
      bottom = _instance2.bottom;

  _this.prevValues = {
    top: top,
    left: left,
    right: right,
    bottom: bottom
  };
};

this.onResizeMoveEnd = function (e) {
  if (canvas.isViewOnly()) return;
  e.stopPropagation();
  if (!_this.resizeEnabled) return;
  var operationMessages = [];
  var message = _drawingUi.drawingUI.getDrawingPositionOperationMessage(_this.instance);
  operationMessages.push(message);

  _drawingUi.drawingUI.applyDrawingPositionOperations({ operationMessages: operationMessages });

  canvas.operation.batchOperation({
    messages: operationMessages,
    onFailure: function onFailure(err) {
      console.log('Drawing resize batchOperation failure: ' + err);
    }
  });
  _drawingUi.drawingUI.resetDragData();
  canvas.multiSelectionIndicatorBox.update();
};

this.onMoveEnd = function (e) {
  if (canvas.isViewOnly()) return;
  e.stopPropagation();
  if (!_this.moveEnabled) return;
  canvas.selectionArea.selectionDisabled = false;
  var operationMessages = [];
  var message = _drawingUi.drawingUI.getDrawingPositionOperationMessage(_this.instance);
  operationMessages.push(message);

  _regionUi.regionUI.applyRegionPositionOperations({ operationMessages: operationMessages });
  _regionUi.regionUI.applyNodePositionOperations({ operationMessages: operationMessages });
  _drawingUi.drawingUI.applyDrawingPositionOperations({ operationMessages: operationMessages });

  canvas.operation.batchOperation({
    messages: operationMessages,
    onFailure: function onFailure(err) {
      console.log('Drawing move batchOperation failure: ' + err);
    }
  });
  _drawingUi.drawingUI.resetDragData();
  canvas.multiSelectionIndicatorBox.update();
};

this.onMove = function (_ref2) {
  var dx = _ref2.dx,
      dy = _ref2.dy;

  if (canvas.isViewOnly()) return;

  var _canvas$getMatrix = canvas.getMatrix(),
      scale = _canvas$getMatrix.scale;

  var instance = _this.instance;
  var top = instance.top,
      left = instance.left;

  dx = dx / scale;
  dy = dy / scale;

  _drawingUi.drawingUI.applyMove({ dx: dx, dy: dy, draggingDrawing: instance });
  _regionUi.regionUI.applyMoveToRegions({ dx: dx, dy: dy });
  _regionUi.regionUI.applyMoveToNodes({ dx: dx, dy: dy });

  _this.update();
};

this.makeNotInteractable = function () {
  (0, _interactjs2.default)(_this.root).unset();
};

this.showTools = function () {
  if (canvas.isViewOnly()) return false;
  return true;
};

this.enableResize = function () {
  if (canvas.isViewOnly()) return;
  _this.resizeEnabled = true;
  _this.update();
};

this.disableResize = function () {
  _this.resizeEnabled = false;
  _this.update();
};

this.enableMovement = function () {
  if (canvas.isViewOnly()) return;
  _this.moveEnabled = true;
  _this.isInteractable = true;
  _this.update();
};

this.summonMenu = function (e) {
  if (canvas.isViewOnly()) return;
  if (e.altKey) return;
  e.stopPropagation();
  e.preventDefault();

  canvas.drawingMenu.summon({
    // referenceEl: this.refs.menuTrigger,
    // id: this.id,
    tag: _this,
    // fromRightClick: e.button && e.button === 2,
    x: e.clientX,
    y: e.clientY
  });
};

this.stopPropagation = function (e) {
  e.stopPropagation();
  e.stopImmediatePropagation();
};

this.refreshPosition = function () {
  var root = _this.root,
      instance = _this.instance;

  root.style.width = instance.right - instance.left + 'px';
  root.style.height = instance.bottom - instance.top + 'px';
  root.style.left = instance.left + 'px';
  root.style.top = instance.top + 'px';
};

this.toggleSelected = function (e) {
  var isMac = canvas.isMac;

  var metaKeyPushed = isMac && e.metaKey || !isMac && e.ctrlKey;

  _selectionUi.selectionUI.resetNodeRects();

  if (_this.isSelected && !metaKeyPushed) {
    _drawingUi.drawingUI.removeDrawingFromSelection(_this.id);
  } else {
    _drawingUi.drawingUI.selectDrawing(_this.id, e.shiftKey);
    if (metaKeyPushed) {
      _selectionUi.selectionUI.selectAllInsideBox(_this.instance, e.shiftKey);
      return;
    }
  }

  if (!e.shiftKey) {
    canvas.clearSelectedElements({ dontClearDrawings: true });
  } else {
    canvas.updateSelectedState();
  }
};

this.setSelected = function () {
  if (!_this.isSelected) {
    _this.isSelected = true;
    _this.enableMovement();
    canvas.bulkActionsMenuTag.update();
  }

  if (canvas.getSelectedElementsCount() > 1) {
    _this.disableResize();
  } else {
    _this.enableResize();
  }
};

this.deSelect = function () {
  if (_this.isSelected) {
    _this.isSelected = false;
    _this.disableResize();
    canvas.bulkActionsMenuTag.update();
  }
};

this.showEdgeHandles = function () {
  if (canvas.getSelectedElementsCount() <= 1) {
    _this.enableResize();
  }
};

this.hideEdgeHandles = function () {
  if (!_this.isSelected) {
    _this.disableResize();
  }
};

this.getDashArray = function () {
  var _instance3 = _this.instance,
      strokeType = _instance3.strokeType,
      strokeWidth = _instance3.strokeWidth;

  return _drawingUi.drawingUI.getDashArray(strokeType, strokeWidth);
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('drawing')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/drawing.html
// module id = 810
// module chunks = 0